// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  deleteUser,
  FacebookAuthProvider,
  getAuth,
  linkWithPopup,
  updateEmail,
  unlink,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  onSnapshot,
  doc,
  deleteDoc,
  updateDoc,
  Timestamp,
  getDoc,
  addDoc,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { toast } from "react-toastify";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAQEByaOiu9PpBXE_NU2E4VcbhBYgpV8cQ",
  authDomain: "asan-dakar.firebaseapp.com",
  projectId: "asan-dakar",
  storageBucket: "asan-dakar.appspot.com",
  messagingSenderId: "641696759418",
  appId: "1:641696759418:web:f040a15e67086d24e345c3",
  measurementId: "G-JZRBST74VJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage();


export const getUsers = () => {
  const reftab = query(collection(db, "users"));

  onSnapshot(reftab, (item) => {
    const data = [];
    item.forEach((i) => {
      data.push({ ...i.data(), id: i.id });
    });
    return data;
  });
};
export const getCollection = (elt_collection, set_state) => {
  const reftab = query(collection(db, `${elt_collection}`));
  const data = [];

  onSnapshot(reftab, (item) => {
    item.forEach((i) => {
      data.push({ ...i.data(), id: i.id });
    });
    set_state(data);
  });
};

export const getDocument = async (elt_collection, elt_id, set_state) => {
  const reftab = doc(db, `${elt_collection}`, `${elt_id}`);
  onSnapshot(reftab, (doc) => {
    set_state({ my_id: doc.id, ...doc.data() });
  });
};

export const updateElement = async (elt_collection, elt_id, data) => {
  const reftab = doc(db, `${elt_collection}`, `${elt_id}`);
  await updateDoc(reftab, {
    ...data,
    editAt: Timestamp.fromDate(new Date()),
  })
    .then(() => {
      toast("Modifier avec succès !");
    })
    .catch((error) => {
      console.log("Error updating book: ", error);
    });

};

export const updateStatusCours = async (elt_id, data, message) => {
  const reftab = doc(db, 'cours', `${elt_id}`);
  await updateDoc(reftab, {
    etudiants: data,
  })
    .then(() => {
      toast(`${message}`);
    })
    .catch((error) => {
      console.log("Error updating book: ", error);
    });
};

export const updateOnFalse = async (
  elt_collection,
  elt_id,
  elt_status,
  elt_message
) => {
  try {
    const docRef = doc(db, `${elt_collection}`, `${elt_id}`);

    await updateDoc(docRef, {
      [elt_status]: false,
      editAt: Timestamp.fromDate(new Date()),
    });
    toast(`${elt_message}`);
  } catch (error) {
    console.error(error);
    toast("Une erreur est survenue lors de la mise à jour du statut");
  }
};
export const updateOnTrue = async (
  elt_collection,
  elt_id,
  elt_status,
  elt_message
) => {
  try {
    const docRef = doc(db, `${elt_collection}`, `${elt_id}`);
    await updateDoc(docRef, {
      [elt_status]: true,
      editAt: Timestamp.fromDate(new Date()),
    });
    toast(`${elt_message}`);
  } catch (error) {
    console.error(error);
    toast("Une erreur est survenue lors de la mise à jour du statut");
  }
};

export const onUpdateEmail = (elt_id, elt_data,navigate) => {
  updateEmail(auth.currentUser, elt_data.email)
    .then(() => {
      updateElement("users", elt_id, elt_data);
      navigate(-1);
    })
    .catch((error) => {
      toast("eurreur de modification, veuillez réessayer !");
      console.log("Error updating book: ", error);
    });
};

export const deleteElement = async (elt_collection, elt_id) => {
  const reftab = doc(db, `${elt_collection}`, `${elt_id}`);

  await deleteDoc(reftab)
    .then(() => {
      toast("Supprimer avec succès");
    })
    .catch((error) => {
      console.log("Error deleting book: ", error);
    });
};

export const onDeleteUser = () => {
  const currentUserId = sessionStorage.getItem("user_id")
  deleteUser(auth?.currentUser)
    .then(() => {
      deleteElement("users", currentUserId);
      sessionStorage.clear()
      window.location.reload()
      toast.success("compte supprimer avec succès !")
    })
    .catch((error) => {
      console.log("Error deleting book: ", error);
    });
};

export const facebookProviderStatus = (elt_email, set_state) => {
  fetchSignInMethodsForEmail(auth, elt_email)
    .then((providers) => {
      let value_set;
      if (providers?.includes('facebook.com')) {
        value_set = true
      } else {
        value_set = false
      }
      return set_state(value_set)
    })
    .catch((error) => {
      console.error('Error fetching providers', error);
    });
}


export const linkWithFacebook = () => {
  const facebookProvider = new FacebookAuthProvider();
  facebookProvider.addScope("email");
  linkWithPopup(auth.currentUser, facebookProvider)
    .then((result) => {
     
      toast.success("Connexion reussie reussie avec facebook !");
    }, )
    .catch((error) => {
      console.error(error.code);
      const message = error.code;
      if (message === "auth/credential-already-in-use") {
        toast.warning(
          "Compte Facebook lié à un autre utilisateur de ASAN School"
        );
      } else if (message === "auth/email-already-in-use") {
        toast.warning(
          "Un autre utilisateur de ASAN School possède dejà l'email fourni par votre compte Facebook"
        );
      } else if (message === "auth/invalid-credential") {
        toast.warning(
          "Les informations d'identification fournies sont invalides ou expirées !"
        );
      } else if (message === "auth/user-disabled") {
        toast.warning("Le compte lié a été désactivé !");
      } else {
        toast.error(
          "Un autre utilisateur de ASAN School possède dejà l'email fourni par votre compte Facebook"
        );
      }
    });
};

export const unLinkedWhithFacebook = () => {
  unlink(auth.currentUser, "facebook.com")
    .then(() => {
      toast.success("Votre compte à été delié avec succès !")
    })
    .catch((error) => {
      toast.error("erreur")
    });
};


export const nmbrCourByStudent = () => {
  const currentUser = JSON.parse(sessionStorage.getItem('user'))
  const reftab = query(collection(db, `cours`));
  const data = []
  onSnapshot(reftab, (item) => {
    item.forEach((doc) => {
      data.push({ ...doc.data(), id: doc.id })
    })
    const allCoursDatas = data.filter((i)=> i?.admin_id === currentUser?.admin_id && i.isArchived === false)

    const statusCoursDatas =  allCoursDatas.map( i =>({...i.etudiants , id_cours : i.id}))

    const studentStatusCours = statusCoursDatas.map(i => i.etudiants_id === currentUser.id)
  
  })
}
nmbrCourByStudent()
export const nmbrStudentByCour = (setNombre, elt_id) => {
  const reftab = doc(db, `cours`, elt_id);
  onSnapshot(reftab, (doc) => {
    const data = doc?.data()["etudiants"]
    setNombre(data)
  })
}


export const nmbrStudentByDomain = (setNombre,domaineCours) => {
  const currentUserId = sessionStorage.getItem('user_id')
  const reftab = query(collection(db, `users`));
  const data = []
  onSnapshot(reftab, (item) => {
    item.forEach((doc) => {
      data.push({ ...doc.data(), id: doc.id })
    })
    const iii = data.filter((i) => i.domaine === domaineCours && i.admin_id === currentUserId && i.user_type==='etudiant')
    setNombre(iii.length);
  })

 
}


export const forNotification = ( message , notificationFOr ) =>{
  const currentUserId = sessionStorage.getItem('user_id')
  addDoc(collection(db, "notification"), {
   message : message,
   notificationBy : currentUserId,
   notificationFOr : notificationFOr ,
   createdOn : Timestamp.fromDate(new Date()),
   isShow : false,
  })
}